// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": 'us-east-1:2b8997c3-99cd-48af-ad5d-e34257f6d029',
    "aws_cognito_region": 'us-east-1',
    "aws_user_pools_id": 'us-east-1_BlTVSNXDO',
    "aws_user_pools_web_client_id": '6310rq8vtokgq0j71pl645nprm',
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://lc6lwn2aabcdvew6vaea67gi4m.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-fvs6o5eavbfrzleu6tmdwxnwzq",
    "aws_user_files_s3_bucket": "bgov-ac-user-media-bgov",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
